import { Component, OnInit } from '@angular/core';

import { Sharedservice } from './../shared.service';
import { UserPermissionService } from '../../services/userPermissions.service'
import { NavigationStart, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {
  public canAccessAnalyticsReport: boolean = false;
  public isFromDaisey = false;
  
  constructor(public sharedService: Sharedservice, public userPermissionService: UserPermissionService, private _router: Router) {
    
  }

  ngOnInit() {
    if (localStorage.getItem('dProjectId')) {
      this.isFromDaisey = true;
      this.sharedService.engagementMenuClicked = true;
    }
    this.userPermissionService.canAccessAnalyticsReport().subscribe(
      (response: any) => {
        this.canAccessAnalyticsReport = response;
      },
      error => { });
  }
}




